import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const TOKEN_STORAGE_KEY = "apollo_bn_session_token";

export function getStoredToken() {
  try {
    return window.localStorage.getItem(TOKEN_STORAGE_KEY) || null;
  } catch {
    return null;
  }
}

export function setStoredToken(token) {
  try {
    if (token) window.localStorage.setItem(TOKEN_STORAGE_KEY, token);
    else window.localStorage.removeItem(TOKEN_STORAGE_KEY);
  } catch {
    /* ignore (e.g. private mode quota) */
  }
}

// Client axios partagé.
// - `withCredentials: true` envoie le cookie `apollo_bn_session` (desktop / Magic Link).
// - L'interceptor ajoute `Authorization: Bearer <token>` si présent dans
//   localStorage. C'est la voie utilisée en mobile iOS WKWebView / Safari ITP
//   où le cookie cross-site est bloqué par le navigateur (le token vient alors
//   du fragment URL `#session=...` lu par bootSessionFromHash()).
export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const token = getStoredToken();
  if (token && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

/**
 * Lit `window.location.hash` au boot. Si on a `#session=<jwt>`, on le stocke
 * dans localStorage et on nettoie l'URL (history.replaceState — pas de
 * navigation, pas de reload). Idempotent.
 *
 * Appelé une seule fois dans index.js avant le rendu React.
 */
export function bootSessionFromHash() {
  if (typeof window === "undefined") return;
  const h = window.location.hash || "";
  if (!h.startsWith("#")) return;
  const params = new URLSearchParams(h.slice(1));
  const tok = params.get("session");
  if (!tok) return;
  setStoredToken(tok);
  // Nettoie le hash sans recharger
  const cleanUrl =
    window.location.pathname + window.location.search;
  window.history.replaceState(null, "", cleanUrl);
}
